import { defineMessages } from "react-intl";

const messages = defineMessages({
    a1_h3: {
        id: "aboutus.bali.h3",
    },
    a1_d: {
        id: "aboutus.bali.p",
    },
    a2_h3: {
        id: "aboutus.molnar.h3",
    },
    a2_d: {
        id: "aboutus.molnar.p",
    },
    a3_h3: {
        id: "aboutus.albert.h3",
    },
    a3_d: {
        id: "aboutus.albert.p",
    },
    a4_h3: {
        id: "aboutus.mich.h3",
    },
    a4_d: {
        id: "aboutus.mich.p",
    },
});

export default messages;
